import { createSelector } from 'reselect';

import { CurrentUser, getUserUuid } from 'src/rematch-models/user';
import { Member } from 'src/models/Common';

import { RootState } from '../config/Store';

export const getCurrentUser = (rootState: RootState) => rootState.user.currentUser as CurrentUser;
export const getUser = (rootState: RootState) => rootState.user;

export const getPartners = (rootState: RootState) => rootState.partners.partners as Member[];

export const getMyAssignmentWithMember = (memberUuid?: string) =>
  createSelector(getPartners, getUserUuid, (partners, userUuid) => {
    const partner = partners.find((p) => p.uuid === memberUuid);
    const assignmentWithMember = partner?.memberAssignments.find(
      (assignment) => assignment.coach.uuid === userUuid,
    );
    if (assignmentWithMember && !assignmentWithMember.member && partner) {
      // This is sometimes being incorrectly used in lieu of a CoachAssignment.
      // TS _says_ assignmentWithMember.member exists, but it doesn't always.
      // Transform data to fit that model until we rip Redux out.
      assignmentWithMember.member = partner;
    }
    return assignmentWithMember;
  });
